<mat-card>
  <mat-icon (click)="closeComponent()">backspace</mat-icon>
</mat-card>

<mat-card>
  <div class="row">
    <div class="col-6">
      <div class="row">Indent: {{route_details['indent_number']}}</div>
    </div>
    <div class="col-6">
      <div class="row">Date: {{route_details['date']}}</div>
      <div class="row">Vehicle No: {{route_details['vehicle_licence_number']}}</div>
    </div>
  </div>
  <div class="row table-dark" style="padding: 5px;">
  <div class="col">Product Name </div>
  <div class="col">Quantity</div>
  </div>
  <div class="row" *ngFor="let product of product_details; ">
  <div class="col">
    {{product['product_name']}}
  </div>
  <div class="col">
    {{product['quantity']}}
    </div>
  </div>
</mat-card>
